<template>
  <div class="banner">
    <!-- <div class="mm"></div> -->
    <!-- <div class="banner-img"> -->
      <img :src="img" class="banner_img" />
    <!-- </div> -->
    <div class="banner-title">
      <!-- <p> -->
        <span>{{title}}</span>
        <span style="font-size:18px;font-weight:200;margin-left:30px;letter-spacing: 1px;">当前位置：聚利和集团&nbsp;/&nbsp;{{title}}</span>
      <!-- </p> -->
    </div>
    <!-- <div class="banner_phone" style="position: absolute;
    color: #fff;
    font-size: 40px;
    font-weight: bold;letter-spacing: 2px;right:10%;bottom:0px;height: 100px;line-height:100px;">
    <img src="../assets/img/phone.png" alt="" style="width:200px;" mode="widthFix">
    </div> -->
    <img src="../assets/img/phone.png" class="banner_phone"  alt="" style="position: absolute;
    right:10%;bottom: 10px;
    width: 260px;
    height: 80px;">
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: "../assets/img/bgtop.jpg"
    }
  }
};
</script>

<style lang="scss" scoped>
.banner_img{
   animation:out 1.5s 1 linear;
}
 @keyframes out{
           0%{
               transform:scale(1.2);
               opacity:0;
           }
           100%{
            transform:scale(1);
            opacity:1;
           }
        }
        .banner-title{
           animation:title 1s 1 linear;
        }
        .banner_phone{
          animation:title1 1s 1 linear;
        }
          @keyframes title1{
           0%{
             margin-bottom:40px;
             opacity: 0;
           }
           100%{
             margin-bottom:0px;
             opacity: 1;
           }
        }
         @keyframes title{
           0%{
             margin-bottom:40px;
             background: rgba(0, 0, 0, 0.1);
             opacity: 0;
           }
           100%{
             margin-bottom:0px;
             background: rgba(0, 0, 0, 0.6);
             opacity: 1;
           }
        }
.banner {
  width: 100%;
  height: 360px;
  position: relative;
  background-color: #000;
  overflow: hidden;
  .mm {
    position: absolute;
    width: 100%;
    height: 100%;

    padding: 10px;
    margin: -10px;
    filter: blur(10px);

    background-image: url(../assets/img/bgtop.jpg);
    background-position: center;
    background-size: 100%;
  }

  img {
    position: absolute;
    //width: 1240px;
    height: 100%;
    width:100%;
  }

  &-title {
    position: absolute;
    color: #fff;
    font-size: 40px;
    font-weight: bold;
    line-height: 100px;
    letter-spacing: 2px;
    height:100px;
    background:rgba(0,0,0,0.4);
    left:0px;
    bottom:0px;
    display: flex;
    justify-content: flex-end;
    padding-left: 10%;
    padding-right: 2%;
  }
}
</style>